import { z } from 'zod'

export enum CalloutType {
  Neutral = 'neutral',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
}

export type AttributesCallout = {
  type: CalloutType
  isEditable?: boolean
  /** Scalar icon format */
  icon?: string
}

export const attributesCalloutSchema = z.object({
  type: z.nativeEnum(CalloutType),
  isEditable: z.boolean().optional(),
  icon: z.string().optional(),
}) satisfies z.ZodType<AttributesCallout>
